module.exports = __webpack_public_path__ + "media/images/front/icon_02_search_gr-0650d53b39d05a652222c3a3039eed0b.png";